"use client";

import { useMemo } from "react";
import { useMessages } from "next-intl";
import type { QuizConfig, QuizSection } from "@/components/GuidedPath/type";
import type en from "@/i18n/messages/en.json";

type GuidedPathMessages = (typeof en)["GuidedPath"];

function normalizeQuizSection(section: QuizSection): QuizSection {
  return {
    ...section,
    description: section.description ?? "",
  };
}

function normalizeQuizConfig(quiz: QuizConfig): QuizConfig {
  return {
    sections: quiz.sections.map((section) => normalizeQuizSection(section)),
  };
}

export function useGuidedPathQuiz(): QuizConfig | null {
  const messages = useMessages();

  return useMemo(() => {
    const guidedPath = messages.GuidedPath as unknown as
      | GuidedPathMessages
      | undefined;
    const quiz = guidedPath?.quiz as QuizConfig | undefined;
    if (!quiz?.sections?.length) {
      return null;
    }
    return normalizeQuizConfig(quiz);
  }, [messages]);
}
